import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostBinding, inject, Input, OnInit, Output } from '@angular/core';

@Component({
  selector:        'koal-button',
  templateUrl:     './koal-button.component.html',
  styleUrls:       ['./koal-button.component.scss'],
  imports: [
    NgClass
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KoalButtonComponent {

  @Input()
  isNavButton: boolean = false;

  @Input()
  disabledCondition = false;

  @Input()
  text: string;

  @Input()
  loading: boolean;

  @Input()
  isFormSubmitButton: boolean;

  @Input()
  buttonTheme: 'outlined' | 'default' | 'red' = 'default';

  @Input()
  leadingIcon: string;

  @Input()
  leadingImageUrl: string;

  @Output()
  clickEvent = new EventEmitter();

}
